export const DAYS_OF_WEEK = ["Pon", "Uto", "Sri", "Čet", "Pet", "Sub", "Ned"];

export const MONTH_NAMES = [
  "Siječanj",
  "Veljača",
  "Ožujak",
  "Travanj",
  "Svibanj",
  "Lipanj",
  "Srpanj",
  "Kolovoz",
  "Rujan",
  "Listopad",
  "Studeni",
  "Prosinac",
];

/**
 * Boje kartica po tipu entiteta — meka podloga, tanki obrub i zasićen tekst,
 * po uzoru na ostale kalendarske prikaze u aplikaciji.
 */
export interface CalendarEventColor {
  background: string;
  border: string;
  /** Jači obrub za zaglavlje kartice u detaljima — svijetli se ondje čita kao sivi. */
  borderStrong: string;
  text: string;
  subtext: string;
  dot: string;
}

export const CALENDAR_EVENT_COLORS: Record<string, CalendarEventColor> = {
  VehicleRegistration: {
    background: "bg-sky-50",
    border: "border-sky-200",
    borderStrong: "border-sky-400",
    text: "text-sky-700",
    subtext: "text-sky-500",
    dot: "bg-sky-500",
  },
  VehicleInsurance: {
    background: "bg-violet-50",
    border: "border-violet-200",
    borderStrong: "border-violet-400",
    text: "text-violet-700",
    subtext: "text-violet-500",
    dot: "bg-violet-500",
  },
  FireExtinguisher: {
    background: "bg-rose-50",
    border: "border-rose-200",
    borderStrong: "border-rose-400",
    text: "text-rose-700",
    subtext: "text-rose-500",
    dot: "bg-rose-500",
  },
  Offer: {
    background: "bg-amber-50",
    border: "border-amber-200",
    borderStrong: "border-amber-400",
    text: "text-amber-700",
    subtext: "text-amber-500",
    dot: "bg-amber-500",
  },
  Contract: {
    background: "bg-emerald-50",
    border: "border-emerald-200",
    borderStrong: "border-emerald-400",
    text: "text-emerald-700",
    subtext: "text-emerald-500",
    dot: "bg-emerald-500",
  },
  Invoice: {
    background: "bg-slate-100",
    border: "border-slate-200",
    borderStrong: "border-slate-400",
    text: "text-slate-700",
    subtext: "text-slate-500",
    dot: "bg-slate-500",
  },
};

export const DEFAULT_CALENDAR_EVENT_COLOR: CalendarEventColor = {
  background: "bg-slate-50",
  border: "border-slate-200",
  borderStrong: "border-slate-400",
  text: "text-slate-700",
  subtext: "text-slate-500",
  dot: "bg-slate-400",
};

/** Koliko kartica stane u ćeliju mjeseca prije nego se ostatak sažme u "+N". */
export const MONTH_CELL_VISIBLE_EVENTS = 3;
